import { Component, OnInit } from '@angular/core';
import { ServiceInstructionService } from 'src/app/core/services/serviceInstruction/serviceInstruction.service';
import { ActivatedRoute } from '@angular/router';
import { IServiceInstructions } from 'src/app/models/IServiceInstructions';


@Component({
  selector: 'app-serviceInstruction',
  templateUrl: './serviceInstruction.component.html',
  styleUrls: ['./serviceInstruction.component.scss'],
  providers:[ServiceInstructionService]
})
export class ServiceInstructionComponent implements OnInit {
  ServiceId: string;
  ServiceName: string;
  Model: IServiceInstructions[];
  InstructonsCount = 0;
  constructor(private serviceInstructionService:ServiceInstructionService,private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      let result = params['encServiceId'] || params['encserviceid'];
      this.ServiceId = result;
    });
  }

  ngOnInit(): void {
    this.loadData();
  }
  loadData(){
    var resulturl = `/api/Queue/GetServiceInstructions?encServiceId=`+this.ServiceId;
    this.serviceInstructionService.getServiceInstructionsData(resulturl).subscribe({
      next:serviceInstructionData => {
        this.ServiceName = serviceInstructionData.Message;
        this.Model = serviceInstructionData.Data.filter(f=>f.Instruction != '');
        this.InstructonsCount = serviceInstructionData.Data.filter(f=>f.Instruction != '').length;
        //this.resultData = new MatTableDataSource<IHistory>(resultData?.Data?.data);
        //this.config.totalRows = 6;
      },
      error:err => {
        //this.errorMessage = err;
      }
    });
  }
  DownloadReport(){

  }
  openViewer(){
    
  }
}
